export const pageHeaderHDBreakpoint = 1366;
export const pageHeaderMobileBreakpoint = 600;
